import { createContext, useState, useEffect } from 'react';

export const HealthContext = createContext();

export function HealthProvider({ children }) {
  const [serverDown, setServerDown] = useState(false);
  const [userOffline, setUserOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleServerDown = () => setServerDown(true);
    const handleServerRestored = () => setServerDown(false);
    const handleUserOffline = () => setUserOffline(true);
    const handleUserOnline = () => setUserOffline(false);

    window.addEventListener('server-unreachable', handleServerDown);
    window.addEventListener('server-restored', handleServerRestored);
    window.addEventListener('user-offline', handleUserOffline);
    window.addEventListener('online', handleUserOnline);
    window.addEventListener('offline', handleUserOffline);

    return () => {
      window.removeEventListener('server-unreachable', handleServerDown);
      window.removeEventListener('server-restored', handleServerRestored);
      window.removeEventListener('user-offline', handleUserOffline);
      window.removeEventListener('online', handleUserOnline);
      window.removeEventListener('offline', handleUserOffline);
    };
  }, []);

  return (
    <HealthContext.Provider value={{ serverDown, setServerDown, userOffline, setUserOffline }}>
      {children}
    </HealthContext.Provider>
  );
}
